<dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" class="input-box-section"
    style="padding: 0 1rem;">
    <dxi-item [ratio]="1" [baseSize]="'auto'" [shrink]="1">
        <div class="header-grid">
            <div class="title">Health Department Profile</div>
        </div>
    </dxi-item>
    <!-- Button item positioned on the right side -->
    <dxi-item [ratio]="1" [baseSize]="'auto'" [shrink]="1">
        <div class="input-field" style="display: flex; justify-content: flex-end; width: 100%;">
            <app-add-button text="Add Health Dept. Profile" (clicked)="AddHealthDepartmentProfile()"
                *ngIf="EntityAuthority?.CanAdd"></app-add-button>
        </div>
    </dxi-item>
</dx-box>


<!-- Table  -->
<div class="table-wrapper">
    <dx-data-grid class="my-grid" [dataSource]="dataSource" [allowColumnResizing]="true"
        (onCellPrepared)="onCellPrepared($event)" [columnAutoWidth]="true" style="width: 100%;">

        <dxo-scrolling mode="standard" scrollByContent="true" useNative="false"></dxo-scrolling>
        <dxo-paging [enabled]="true" [pageSize]="pageSize"></dxo-paging>
        <dxo-pager [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>

        <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" [width]="250" placeholder="Search here...">
        </dxo-search-panel>

        <dxi-column caption="Sr. No" cellTemplate="idTemplate" alignment="center" [minWidth]="80"></dxi-column>

        <dxi-column caption="Action" alignment="center" cellTemplate="actionTemplate" [minWidth]="100"></dxi-column>

        <dxi-column caption="NameEn" dataField="p.name_en" alignment="center" [minWidth]="150"></dxi-column>
        <dxi-column caption="NameMr" dataField="p.name_mr" alignment="center" [minWidth]="150"></dxi-column>
        <dxi-column caption="Designation" dataField="p.designation_en" alignment="center" [minWidth]="150"></dxi-column>
        <dxi-column caption="Designation" dataField="p.designation_mr" alignment="center" [minWidth]="150"></dxi-column>
        <dxi-column caption="Seniority Level" dataField="p.seniority_level" alignment="center" [minWidth]="50"></dxi-column>

        <dxi-column caption="Icon" width="150" alignment="center" cellTemplate="iconTemplate">
        </dxi-column>

        <div *dxTemplate="let cell of 'iconTemplate'">
            <img *ngIf="cell.data.p.image_blob_url" [src]="cell.data.p.image_blob_url"
                style="height:80px;width:80px;object-fit:cover;border-radius:4px" />
        </div>

        <!-- Action Template -->
        <div *dxTemplate="let data of 'actionTemplate'">
            <div style="display: flex; justify-content: center; gap: 10px">
                <img src="assets/icons/edit.png" alt="Edit" style="width: 20px; height: 20px; cursor: pointer"
                    (click)="onEditClicked(data,OperationalModes.CanEdit)" *ngIf="EntityAuthority?.CanEdit" />
                <img src="assets/icons/view.png" alt="View" style="width: 20px; height: 25px; cursor: pointer"
                    (click)="onEditClicked(data,OperationalModes.CanView)" *ngIf="EntityAuthority?.CanView" />
                <img src="assets/icons/delete.png" alt="Delete" style="width: 20px; height: 20px; cursor: pointer"
                    (click)="OnDeleteClicked(data)" *ngIf="EntityAuthority?.CanDelete" />
            </div>
        </div>

    </dx-data-grid>
</div>
<!-- <app-contraceptive-pills-opening-stock-master-details (wheel)="$event.stopPropagation()" [isModalOpen]="isModalOpen"
  [title]="'Add Contraceptive Pills Opening Stock'" (close)="closeModal()"
  (ContraceptivePillsOpeningStockSaved)="onContraceptivePillsOpeningStockSaved()"></app-contraceptive-pills-opening-stock-master-details> -->